// src/pages/SupportPage.jsx
import { Link } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock, FaQuestionCircle } from 'react-icons/fa';
import Layout, { useLanguage } from '../components/Layout';

export default function SupportPage() {
  const { t } = useLanguage();

  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>{t('support.title') || 'Support Center'}</h1>
          <p className="page-subtitle">
            {t('support.subtitle') || "We're here to help you stay connected"}
          </p>

          <div className="support-grid-page">
            <div className="support-card-page">
              <h2><FaQuestionCircle /> {t('support.faq.title') || 'Frequently Asked Questions'}</h2>
              <div className="faq-item">
                <h4>{t('support.faq.q1') || 'How do I check coverage in my area?'}</h4>
                <p>
                  {t('support.faq.a1') || 'Visit our '} 
                  <Link to="/coverage">{t('support.faq.coverageLink') || 'Coverage Map'}</Link> 
                  {t('support.faq.a1b') || ' page or contact us directly to check if your location is covered.'}
                </p>
              </div>
              <div className="faq-item">
                <h4>{t('support.faq.q2') || 'What equipment do I need?'}</h4>
                <p>
                  {t('support.faq.a2') || 'We provide all necessary equipment upon approval of your application. Installation is included.'}
                </p>
              </div>
              <div className="faq-item">
                <h4>{t('support.faq.q3') || 'How long does installation take?'}</h4>
                <p>
                  {t('support.faq.a3') || 'Installation typically takes 24-48 hours after approval and payment confirmation.'}
                </p>
              </div>
              <div className="faq-item">
                <h4>{t('support.faq.q4') || 'Do you have data caps?'}</h4>
                <p>
                  {t('support.faq.a4') || 'No! All our residential and business plans include unlimited data with no caps.'}
                </p>
              </div>
              <div className="faq-item">
                <h4>{t('support.faq.q5') || 'What payment methods do you accept?'}</h4>
                <p>
                  {t('support.faq.a5') || 'We accept M-Pesa, bank transfers, and cash payments at our offices.'}
                </p>
              </div>
            </div>

            <div className="support-card-page">
              <h2>{t('support.contact.title') || 'Contact Information'}</h2>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <strong>{t('support.contact.phone') || 'Phone'}</strong>
                  <p><a href="tel:0730320000">0730 320 000</a></p>
                </div>
              </div>
              <div className="contact-item">
                <FaWhatsapp className="contact-icon" />
                <div>
                  <strong>WhatsApp</strong>
                  <p><a href="https://wa.me/254730320000">{t('support.contact.chat') || 'Chat with us'}</a></p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>{t('support.contact.email') || 'Email'}</strong>
                  <p><a href="mailto:hello@nexcom.ke">hello@nexcom.ke</a></p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>{t('support.contact.location') || 'Location'}</strong>
                  <p>{t('support.contact.locationValue') || 'Kisumu, Kenya'}</p>
                </div>
              </div>
              <div className="contact-item">
                <FaClock className="contact-icon" />
                <div>
                  <strong>{t('support.contact.hours') || 'Business Hours'}</strong>
                  <p>{t('support.contact.monFri') || 'Monday - Friday: 8:00 AM - 6:00 PM'}</p>
                  <p>{t('support.contact.sat') || 'Saturday: 9:00 AM - 2:00 PM'}</p>
                </div>
              </div>
              <Link to="/contact" className="contact-btn">
                <FaEnvelope /> {t('support.contact.button') || 'Contact Support'}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}